<template>
  <!--
      	作者：gmshop
      	时间：2020-06-01
      	描述：插件中心-分销-提现申请-弹窗
      -->
  <div >
    <el-dialog title="商家转账到零钱信息" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form">
        <el-form-item label="交易号" :label-width="formLabelWidth" v-if="detail.batch_id">
          <div >
            {{detail.batch_id}}
          </div>

        </el-form-item>
        <el-form-item label="转账订单号" :label-width="formLabelWidth" v-if="detail.out_batch_no">
          <div >
            {{detail.out_batch_no}}
          </div>

        </el-form-item>
        <el-form-item label="转账订单详情号" :label-width="formLabelWidth" v-if="detail.out_detail_no">
          <div >
            {{detail.out_detail_no}}
          </div>

        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <div v-if="detail.detail_status =='FAIL'">
            <span class="red">转账失败</span>
          </div>
          <div v-if="detail.detail_status =='SUCCESS'">
            <span class="green">转账成功</span>
          </div>
        </el-form-item>
        <el-form-item label="提示" :label-width="formLabelWidth" v-if="detail.detail_status =='FAIL'">
          <div >
            <span class="red">{{detail.error_msg}}</span>
          </div>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BalanceApi from '@/api/balance.js';
export default {
  data() {
    return {
      detail:[],
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: ['open_status', 'form'],
  created() {
    this.dialogVisible = this.open_status;
    this.getData()
  },
  methods: {

    /*数据*/
    getData() {
      let self = this;
      let params = this.form;

      BalanceApi.transfersDetail(params, true)
        .then(data => {
          this.detail= data.data;
          console.log(data)
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/balance/part/dialog/Paystatus.vue